import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { CoreAnalytics } from '@core-modules/analytics/providers/core-analytics';
import { CoreDialogController } from '@core-modules/providers/core-dialogs/core-dialog-controller';
import { DeviceProvider } from '@core-modules/providers/device/device';
import { NavController } from '@ionic/angular';
import { CoreConfiguration } from 'app/providers/core-configuration';
import { LoginComponent } from 'authorization/helper-classes/login-component';
import { LoginEndResult } from 'authorization/models/login-end-result';
import { AuthProvider } from 'authorization/providers/auth/auth-provider';
import { MessagePageController } from 'messages/providers/message-page-controller';
import { IntercomSupportProvider } from 'user-settings/providers/intercom-support';

@Injectable({
    providedIn: 'root'
})
export class LoginEntryResolverService extends LoginComponent   {

    //#region Constructor

    /**
     * Class Constructor
     */
    constructor
        (
            auth: AuthProvider,
            private coreDialog: CoreDialogController,
            analytics: CoreAnalytics,
            navCtrl: NavController,
            device: DeviceProvider,
            coreConfig: CoreConfiguration,
            route: ActivatedRoute,
            intercom: IntercomSupportProvider,
            messagePageController : MessagePageController
        )
    {
        super(navCtrl, device, coreConfig, route, intercom, analytics, auth, messagePageController);
    }
    //#endregion


    //#region Methods

    /**
     * @param route 
     * @returns return url from azure
     */
    async resolve(route: ActivatedRouteSnapshot): Promise<LoginEndResult>
    {
        let returnUrl = route.queryParamMap.get('param');

        // show a loading spinner
        await this.coreDialog.showLoader();

        let loginEndResult = await this.auth.logInEnd(returnUrl);
        await this.coreDialog.hideLoader();
        return Promise.resolve(loginEndResult);

    }
    //#endregion

}